import ScrollReveal from '@/components/common/ScrollReveal';
import GradientIcon from '@/components/common/GradientIcon';
import { securityCards, securityControls } from '@/mocks/landing';

export default function Security() {
  return (
    <section id="security" className="w-full bg-white pb-16 md:pb-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-[#dfe9ff] via-[#eef3ff] to-[#f8faff] px-5 py-10 md:px-16 md:py-14">
          {/* globe + orbit decoration */}
          <div className="pointer-events-none absolute -right-24 -top-10 w-[560px] h-[560px] rounded-full bg-[radial-gradient(circle_at_35%_35%,#ffffff_0%,#e3ecff_45%,#c9d9ff_100%)] opacity-80" />
          <svg className="pointer-events-none absolute right-0 top-6 w-[520px] h-[260px] opacity-80" viewBox="0 0 520 260" fill="none">
            <path d="M20 240 C 140 20, 360 -10, 500 140" stroke="#6f9bff" strokeWidth="3" strokeLinecap="round" />
            <path d="M120 250 C 230 90, 400 60, 510 90" stroke="#9db7ff" strokeWidth="2" strokeLinecap="round" />
          </svg>

          <div className="relative">
            <ScrollReveal animation="fade-up">
              <span className="inline-block text-[10px] font-bold rounded-md bg-gradient-to-r from-[#ff4d8d] to-[#ff8a5c] text-white px-2 py-0.5 mb-3">
                SECURE
              </span>
              <p className="text-xs text-[#646a73]">Security built into every request</p>
              <h2 className="mt-2 text-2xl md:text-[32px] md:leading-tight font-bold text-[#1f2329] tracking-tight">
                Protecting every point,
                <br />
                every member, every platform
              </h2>
            </ScrollReveal>

            <div className="mt-8 grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-4">
              <div className="space-y-4">
                {securityCards.map((c, i) => (
                  <ScrollReveal key={c.title} animation="fade-up" delay={i * 80} className="rounded-2xl bg-white/90 backdrop-blur p-5 flex items-center gap-4 shadow-sm">
                    <div className="flex-1">
                      <div className="text-[11px] text-[#8f959e]">{c.kicker}</div>
                      <div className="mt-1 font-bold text-[#1f2329]">{c.title}</div>
                    </div>
                    <span className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#eaf1ff] to-white shadow-[0_10px_24px_-12px_rgba(47,81,214,0.6)] flex items-center justify-center">
                      <GradientIcon icon={c.icon} tone={c.tone} size="text-4xl" />
                    </span>
                  </ScrollReveal>
                ))}
              </div>

              <ScrollReveal animation="fade-up" delay={120} className="rounded-2xl bg-white/95 backdrop-blur p-5 md:p-6 shadow-sm">
                <div className="flex items-baseline justify-between gap-4">
                  <h3 className="font-bold text-[#1f2329]">Security controls</h3>
                  <span className="text-[10px] text-[#8f959e] text-right">Applied to every API key and dashboard user</span>
                </div>
                <div className="mt-5 grid grid-cols-2 sm:grid-cols-4 gap-x-3 gap-y-5">
                  {securityControls.map((s) => (
                    <div key={s.label} className="flex flex-col items-center text-center gap-1.5">
                      <span className="w-11 h-11 rounded-full bg-[#f2f5ff] flex items-center justify-center">
                        <GradientIcon icon={s.icon} tone="indigo" size="text-xl" />
                      </span>
                      <span className="text-[11px] text-[#646a73]">{s.label}</span>
                    </div>
                  ))}
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
